var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{attrs:{"height":"100%"}},[_c('v-card-title',[_vm._v("\n      Linked Tickets\n    ")]),_c('v-card-text',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.getLinkedTickets,"hide-default-footer":""},scopedSlots:_vm._u([{key:"item.last_changed",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm._f("formatDate")(item.last_changed)))]}},{key:"item.id",fn:function(ref){
var item = ref.item;
return [_c('a',{attrs:{"href":("/tickets/" + (item.id) + "/")}},[_vm._v(_vm._s(item.id))])]}},{key:"item.freshdesk_id",fn:function(ref){
var item = ref.item;
return [_c('a',{attrs:{"href":(_vm.freshdeskTicketsDomain + "/" + (item.freshdesk_id)),"target":"_blank"}},[_vm._v(_vm._s(item.freshdesk_id))])]}},{key:"item.agent",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm._f("customPlaceholder")(item.agent)))]}},{key:"item.status",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm._f("customPlaceholder")(item.status)))]}},{key:"item.department",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm._f("customPlaceholder")(item.department)))]}}])})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }